import { Controller, Post, Body } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { WarehouseService } from './warehouse.service';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { StockInRequestDto } from './dto/stock-in.request.dto';
import { StockInResponseData } from '@gtpl/shared-models/analytics-data';
import { CommonResponse, ExpectedStockInOutResponse, PlantIdRequest } from '@gtpl/shared-models/warehouse-management'
import { AnalyticsUnitRequest } from './dto/analytics-unit.request';
@ApiTags('Warehouse')
@Controller('warehouse')
export class WarehouseController {
    constructor(private  warehouseService: WarehouseService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler){}

    @Post('/getStockInfo')
    async getStockInfo(@Body() dtoObj: StockInRequestDto): Promise <StockInResponseData> {
        try {
            return await this.warehouseService.getStockInfo(dtoObj);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(StockInResponseData, Error);
        }
    }

    @Post('/getTodaysStockOutSOs')
    async getTodaysStockOutSOs(@Body() req:AnalyticsUnitRequest): Promise <CommonResponse> {
        try {
            return await this.warehouseService.getTodaysStockOutSOs(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }
    @Post('/getrecentFiveStockIns')
    async getrecentFiveStockIns(@Body() req:AnalyticsUnitRequest): Promise <CommonResponse> {
        try {
            return await this.warehouseService.getrecentFiveStockIns(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }
    @Post('/getrecentFiveStockOuts')
    async getrecentFiveStockOuts(@Body() req:AnalyticsUnitRequest): Promise <CommonResponse> {
        try {
            return await this.warehouseService.getrecentFiveStockOuts(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }
    @Post('/getTodayStockTransfers')
    async getTodayStockTransfers(@Body() req:AnalyticsUnitRequest): Promise <CommonResponse> {
        try {
            return await this.warehouseService.getTodayStockTransfers(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }
    @Post('/getCartonsInWayRacks')
    async getCartonsInWayRacks(@Body() req:AnalyticsUnitRequest): Promise <CommonResponse> {
        try {
            return await this.warehouseService.getCartonsInWayRacks(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }
    @Post('/getLongRunningDummyStock')
    async getLongRunningDummyStock(@Body() req:AnalyticsUnitRequest): Promise <CommonResponse> {
        try {
            return await this.warehouseService.getLongRunningDummyStock(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }
    @Post('/getWarehouseCapacity')
    async getWarehouseCapacity(@Body() req:AnalyticsUnitRequest): Promise <CommonResponse> {
        try {
            return await this.warehouseService.getWarehouseCapacity(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }
    @Post('/getPOsProductionAbove70Perc')
    async getPOsProductionAbove70Perc(@Body() req:AnalyticsUnitRequest): Promise <CommonResponse> {
        try {
            return await this.warehouseService.getPOsProductionAbove70Perc(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }
    @Post('/getTransferdSOsStock')
    async getTransferdSOsStock(@Body() req:AnalyticsUnitRequest): Promise <CommonResponse> {
        try {
            return await this.warehouseService.getTransferdSOsStock(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }
    @Post('/getRepackingEfficiency')
    async getRepackingEfficiency(@Body() req:AnalyticsUnitRequest): Promise <CommonResponse> {
        try {
            return await this.warehouseService.getRepackingEfficiency(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }

    @Post('/getExpectedStockInsAndStockOuts')
    async getExpectedStockInsAndStockOuts(@Body() req:AnalyticsUnitRequest): Promise <ExpectedStockInOutResponse> {
        try {
            return await this.warehouseService.getExpectedStockInsAndStockOuts(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }
    @Post('/getWarehouseLifeCycle')
    async getWarehouseLifeCycle(@Body() req:AnalyticsUnitRequest): Promise <ExpectedStockInOutResponse> {
        try {
            return await this.warehouseService.getWarehouseLifeCycle(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }

    @Post('/getTop10DummyProducts')
    async getTop10DummyProducts(@Body() req:AnalyticsUnitRequest): Promise <ExpectedStockInOutResponse> {
        try {
            return await this.warehouseService.getTop10DummyProducts(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }
}
